import './App.css';
import {useEffect, useState} from "react";
import PersonsTable from "./PersonsTable";
import {Grid} from "@mui/material";
import SectorsTable from "./SectorTable";

function App() {

    const [persons, setPersons] = useState([]);
    const [sectors, setSectors] = useState([]);
    const [personsLoading, setPersonsLoading] = useState(false);
    const [sectorsLoading, setSectorsLoading] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const groups = params ? params.get("groups") : 0
    const perpage = params ? params.get("perpage") : 0

    const loadDataPersons = async (pGroups) => {
        try {
            setPersonsLoading(true)
            if (pGroups) {
                const response = await fetch(`https://painel.aric.com.br:8091/api/v1/ticket/dashboard/persons?groups=${pGroups}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                });
                if (response) {
                    setPersons(await response.json());
                }
            }
        } catch (e) {
            console.log(e)
        } finally {
            setPersonsLoading(false)
        }
    }

    const loadDataSectors = async (pGroups) => {
        try {
            setSectorsLoading(true)
            if (pGroups) {
                const response = await fetch(`https://painel.aric.com.br:8091/api/v1/ticket/dashboard/sector?groups=${pGroups}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                });
                if (response) {
                    setSectors(await response.json());
                }
            }
        } catch (e) {
            console.log(e)
        } finally {
            setSectorsLoading(false)
        }
    }

    const loadData = async (pGroups) => {
        await Promise.all([loadDataPersons(pGroups), loadDataSectors(pGroups)])
    }

    useEffect(() => {
        if (groups) {
            loadData(groups)
        }
    }, [])

    useEffect(() => {
        if (groups) {
            const intervalId = setInterval(() => {
                loadData(groups)
            }, 120000)
            return () => {
                clearInterval(intervalId);
            };
        }
    }, [persons, sectors])

    return (
        <Grid container direction="row" spacing={1} sx={{px: 2, py: 1}}>
            <Grid item xs={12}>
                <SectorsTable data={sectors} loading={sectorsLoading}/>
            </Grid>
            <Grid item xs={12}>
                <PersonsTable data={persons} perpage={+perpage} loading={personsLoading}/>
            </Grid>
        </Grid>
    )
}

export default App;
